import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ARTICLE_TEMPLATES, DEFAULT_TEMPLATE } from '../../../components/ArticleTemplate/constants';
import GalleryTemplate from '../../../components/ArticleTemplate/GalleryTemplate';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const ArticleDetail = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [article, setArticle] = useState(state?.article);
  const [loading, setLoading] = useState(!state?.article);
  const [error, setError] = useState(null);
  
  const templateType = article?.templateType || DEFAULT_TEMPLATE;

  useEffect(() => {
    const fetchArticle = async () => {
      if (!state?.article && id) {
        try {
          setLoading(true);
          const db = getFirestore();
          const articleRef = doc(db, 'articles', id);
          const articleDoc = await getDoc(articleRef);
          
          if (articleDoc.exists()) {
            setArticle({ id: articleDoc.id, ...articleDoc.data() });
          } else {
            setError('Article not found');
          }
        } catch (err) {
          console.error('Error fetching article:', err);
          setError('Failed to load article');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchArticle();
  }, [id, state?.article]);

  if (loading) {
    return (
      <div className="flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <ProgressSpinner />
      </div>
    );
  }

  if (error || !article) {
    return <div className="p-4">Article not found</div>;
  }

  switch (templateType.toUpperCase()) {
    case ARTICLE_TEMPLATES.GALLERY.toUpperCase():
      return <GalleryTemplate article={article} />;
    
    case ARTICLE_TEMPLATES.STANDARD.toUpperCase():
    default:
      return (
        <div className="standard-article">
          <h1>{article.title}</h1>
          {article.image?.url && (
            <div className="main-image mb-4">
              <img 
                src={article.image.url} 
                alt={article.image.alt || article.title}
                className="w-full rounded-lg shadow-2"
              />
            </div>
          )}
          <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />
        </div>
      );
  }
};

export default ArticleDetail;
